@let filters = editedFiltersSg();
@let userOptions = userOptionsSg();

<atn-ds-slideout-overlay name="Filters">
  <i
    actions
    class="atn-icon atn-close atn-red"
    (click)="cancelClickHandler()"
  ></i>

  <div class="atn-space-record-filters">
    <div class="atn-space-record-filters__content">
      <atn-space-dimension-filter [plugin]="spaceDimensionFilterPlugin" />
      <atn-space-dimension-filter [plugin]="roomTypeDimensionFilterPlugin" />
      <atn-space-dimension-filter
        [plugin]="organizationDimensionFilterPlugin"
      />
      <atn-space-dimension-filter [plugin]="clusterDimensionFilterPlugin" />

      <atn-ds-select-multiple
        label="Last Updated By"
        [config]="{
          overlay: {
            minSearchCharacters: 1,
            hasSearch: true,
          },
        }"
        [items]="userOptions"
        [value]="filters?.lastUpdatedBy ?? []"
        (valueChange)="lastUpdatedByChanged($event)"
      />

      <atn-ds-select-multiple
        label="Status"
        [config]="{
          overlay: {
            minSearchCharacters: 1,
            hasSearch: true,
          },
        }"
        [items]="statusOptions"
        [value]="filters?.surveyStatuses ?? []"
        (valueChange)="statusesChanged($event)"
      />

      <div class="atn-space-record-filters__area-field">
        <div class="atn-space-record-filters__area-label">Area</div>
        <div class="atn-space-record-filters__area-inputs">
          <atn-ds-number
            [value]="filters?.sqftMin"
            (change)="areaChanged($event, filters?.sqftMax)"
            placeholder="From"
          />
          <atn-ds-number
            [value]="filters?.sqftMax"
            (change)="areaChanged(filters?.sqftMin, $event)"
            placeholder="To"
          />
        </div>
      </div>
    </div>

    <div class="atn-space-record-filters__footer">
      <atn-ds-button
        type="transparent"
        (click)="resetClickHandler()"
      >
        Reset
      </atn-ds-button>

      <div class="atn-space-record-filters__footer-buttons">
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
        >
          Cancel
        </atn-ds-button>
        <atn-ds-button (click)="applyClickHandler()">Apply</atn-ds-button>
      </div>
    </div>
  </div>
</atn-ds-slideout-overlay>
